// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Kw6v","additionalInfo":"AgreementModal_additionalInfo__2PfMh"};